import { createSlice } from "@reduxjs/toolkit";

import { getAllArticle, createArticle, getArticleDetail, toggleActiveArticle, editArticle } from "./ArticleThunk";

const initialState = {
  allArticle: null,
  allArticleErr: null,
  createArtSuccess: null,
  createArtErr: null,
  articleDetailSuccess: null,
  articleDetailErr: null,
  toggleArtSuccess: null,
  toggleArtErr: null,
  editArtSuccess: null,
  editArtErr: null,
};

const articleSlice = createSlice({
  name: "healthArticle",
  initialState,
  reducers: {
    resetAllArticle(state) {
      state.allArticleErr = null;
    },
    resetCreateArt(state) {
      state.createArtErr = null;
      state.createArtSuccess = null;
    },
    resetArticleDetail(state) {
      state.articleDetailErr = null;
      state.articleDetailSuccess = null;
    },
    resetToggleArticle(state) {
      state.toggleArtErr = null;
      state.toggleArtSuccess = null;
    },
    resetEditArticle(state) {
      state.editArtErr = null;
      state.editArtSuccess = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL ARTICLE LIST
      .addCase(getAllArticle.fulfilled, (state, action) => {
        state.allArticle = action.payload;
      })
      .addCase(getAllArticle.rejected, (state, action) => {
        state.allArticleErr = action.error.message;
      })
      // CREATE ARTICLE
      .addCase(createArticle.fulfilled, (state, action) => {
        state.createArtSuccess = action.payload;
      })
      .addCase(createArticle.rejected, (state, action) => {
        state.createArtErr = action.error.message;
      })
      // GET SINGLE ARTICLE DETAILS
      .addCase(getArticleDetail.fulfilled, (state, action) => {
        state.articleDetailSuccess = action.payload;
      })
      .addCase(getArticleDetail.rejected, (state, action) => {
        state.articleDetailErr = action.error.message;
      })
      // Toggle active ARTICLE
      .addCase(toggleActiveArticle.fulfilled, (state, action) => {
        state.toggleArtSuccess = action.payload;
      })
      .addCase(toggleActiveArticle.rejected, (state, action) => {
        state.toggleArtErr = action.error.message;
      })
      // Edit ARTICLE
      .addCase(editArticle.fulfilled, (state, action) => {
        state.editArtSuccess = action.payload;
      })
      .addCase(editArticle.rejected, (state, action) => {
        state.editArtErr = action.error.message;
      });
  },
});

export const { resetAllArticle, resetCreateArt, resetArticleDetail, resetToggleArticle, resetEditArticle } = articleSlice.actions;
export default articleSlice.reducer;
